import {KeyValue} from '~utils/value-key';

export interface VersionVo {
  codigoOperacao: string;
  data: string;
  routes: string[];
  routesVersions: number[];
  version: number;
  versions?: KeyValue<number>;
  orders?: KeyValue<number>;
  routesProcessed?: string[];
  percProcess?: number;
}

export const emptyVersion = (): VersionVo => (
  {
    codigoOperacao: '',
    data: '',
    routes: [],
    routesVersions: [],
    version: 0,
    versions: {},
    percProcess: 0,
  });
